// import Sass
import './style.scss';

import func from './Const/functions';
const { parallaxInit } = func;

// Parallax Section
document.addEventListener('DOMContentLoaded', () => {
    const allParallaxSection = document.querySelectorAll('.wp-block-psb-parallax');
    Object.values(allParallaxSection).map(parallaxSection => {
        const parallaxImgEl = document.querySelector(`#${parallaxSection.id} .psbParallaxImg`);

        parallaxInit(parallaxImgEl, parallaxImgEl.parentElement);

        document.addEventListener('scroll', () => {
            parallaxInit(parallaxImgEl, parallaxImgEl.parentElement);
        });
    });
});